import _ from "lodash";
import { OptionalTransactionType, TransactionType, BalanceCategory } from "./types";
import rawCategories from "./rawCategories.json"

const allSubcategories = rawCategories.flatMap(category => {
    return category.subcategories.map(subcategory => ({
        ...subcategory,
        section: category.category
    }));
});
const categoriesByGroup = _.groupBy(allSubcategories, 'group');
const categoriesBySectionInGroups = _.mapValues(categoriesByGroup, (subcategories) => {
    return _.groupBy(subcategories, 'section');
});

export function mapToBalanceCategory(
    transactionGroup: OptionalTransactionType | TransactionType
): BalanceCategory {
    switch (transactionGroup) {
        case OptionalTransactionType.SAVINGS:
        case TransactionType.TRANSFERS:
        case OptionalTransactionType.INVESTMENTS:
            return BalanceCategory.ASSET;

        case TransactionType.DEBTS:
        case TransactionType.BILLS:
        case TransactionType.SUBSCRIPTIONS:
            return BalanceCategory.LIABILITY;

        case TransactionType.INCOME:
        case OptionalTransactionType.EXPENSES:
        case OptionalTransactionType.GUILT_FREE:
            return BalanceCategory.EQUITY;

        default:
            return BalanceCategory.EQUITY;
    }
}

export function getCategoryIdByName(name: string): string | undefined {
    return _.get(_.find(allSubcategories, { name }), 'id');
}

export function getCategoriesBySection(section: OptionalTransactionType | TransactionType) {
    return allSubcategories.filter(subcategory => subcategory.section === section);
}

export { rawCategories, allSubcategories, categoriesByGroup, categoriesBySectionInGroups };
